<template>
  <div class="nav">
    <b-nav>
      <b-nav-item active>fancy quiz app</b-nav-item>
      <b-nav-item>counter: {{ numCorrect }}/{{ numTotal }}</b-nav-item>
    </b-nav>
  </div>
</template>

<script>
export default {
  name: 'questionsnav',
  props: ['numCorrect', 'numTotal']
}
</script>
